import { useEffect } from 'react';
import { useAuth } from 'shared/providers/AuthProvider';

const Logout = (): JSX.Element | null => {
  const { logout } = useAuth();
  useEffect(() => {
    logout();
  }, [logout]);
  return null;
};

export default Logout;
